export const modulationReportCachekeys = {
  report: (report_id: number) => ['modulation_report', report_id] as const
}
